import type { IconProps } from "@mui/material/Icon"
import Icon from "@mui/material/Icon"

export default function IconWrapper(props: IconProps) {
  return (
    <Icon
      {...props}
      sx={{
        width: "3rem",
        height: "3rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...props?.sx
      }}
    />
  )
}
